exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "tbody.status-table{border-bottom-style:hidden}", ""]);
